// What the floor screens say about an action whose answer was lost (ScanField and useFloorAction in ./ui).
import type { FloorAction } from './api';

/** How an action is named to the person ("son okutma") and whether it took ("SAYILDI" / "SAYILMADI"). */
export interface ActionWords {
  readonly what: string;
  readonly done: string;
  readonly notDone: string;
}

export const SCAN_WORDS: ActionWords = { what: 'son okutma', done: 'SAYILDI', notDone: 'SAYILMADI' };

/** A button's action: "“Paketlemeyi tamamla” YAPILDI" (a "geri al" is not "sayıldı"). */
export const buttonWords = (label: string): ActionWords => ({ what: `“${label}”`, done: 'YAPILDI', notDone: 'YAPILMADI' });

/** "son okutma sayıldı mı" */
export const asked = (words: ActionWords) => `${words.what} ${words.done.toLocaleLowerCase('tr-TR')} mı`;

export interface Notice {
  readonly tone: 'ok' | 'bad';
  readonly text: string;
}

/**
 * Said after a lost action was sent again: whether it counted, plainly. A refusal gives no advice of
 * its own (the screen shows the reason; the same request is refused again), and nothing is said
 * when the screen answered in its own words (KARGOYA VERMEYİN, a barcode to teach).
 */
export function resentNotice(words: ActionWords, action: FloorAction): Notice | null {
  if (action.answered) return null;
  if (action.outcome === 'counted') return { tone: 'ok', text: `Bağlantı koptu — ${words.what} ${words.done}.` };
  if (action.outcome === 'refused') return { tone: 'bad', text: `Bağlantı koptu — ${words.what} ${words.notDone}.` };
  return null;
}

/**
 * What the scan field leaves behind when its screen closes. unknown: the scan whose answer was lost
 * (held, or on its way again); notCounted: scans that will not count (behind a lost one, or stopped
 * when the session ended). Scans behind a first try still on its way go on by themselves.
 */
export function scansLeftText(left: { readonly unknown: boolean; readonly notCounted: number }): string | null {
  if (left.unknown) {
    const behind = left.notCounted > 0 ? ` Sıradaki ${left.notCounted} okutma gönderilmedi.` : '';
    return `Bağlantı koptu — son okutma sayıldı mı belli değil.${behind} Ekrana dönüp adede bakın.`;
  }
  return left.notCounted > 0 ? `Son ${left.notCounted} okutma sayılmadı. Ekrana dönüp adede bakın.` : null;
}
